import React from 'react';

const TwitterIcon = ({ width = 20, height = 20, className }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1C5.02961 1 1 5.02961 1 10C1 14.9704 5.02961 19 10 19C14.9704 19 19 14.9704 19 10C19 5.02961 14.9704 1 10 1Z"
      fill="currentColor"
    />
    <path
      d="M10.9855 9.18558L14.8382 4.70703H13.9253L10.5799 8.59571L7.90794 4.70703H4.82617L8.86666 10.5874L4.82617 15.2838H5.73921L9.27202 11.1773L12.0938 15.2838H15.1756L10.9855 9.18558ZM6.06819 5.39436H7.47056L13.9257 14.6278H12.5233L6.06819 5.39436Z"
      fill="white"
    />
  </svg>
);

export default TwitterIcon;
